module.exports = __webpack_public_path__ + "img/0c681d7.jpg";